



















import MatchChooser from "@/components/MatchChooser.vue";
import ImageViewer from "@/components/ImageViewer.vue";
import TextViewer from "@/components/TextViewer.vue";
import MatchCommit from "@/components/MatchCommit.vue";
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  components: {
    MatchChooser,
    ImageViewer,
    TextViewer,
    MatchCommit
  }
})
export default class Spa extends Vue {
  created() {
    this.$store.commit("scroll_idSet", null);
    this.$store.commit("image_catalog_idSet", null);
    this.$store.commit("imageInfoSet", null);
    this.$store.commit("edition_catalog_idSet", null);
    this.$store.commit("edition_nameSet", null);
    this.$store.commit("edition_volumeSet", null);
    this.$store.commit("edition_location_1Set", null);
    this.$store.commit("edition_location_2Set", null);
    this.$store.commit("edition_sideSet", null);
    this.$store.commit("col_idSet", null);
    this.$store.commit("colInfoSet", null);
    this.$store.commit("confirmed_by_nameSet", null);
    this.$store.commit("confirmedSet", null);
    this.$store.commit("scrollsSet", []);
  }
}
